import React from 'react';
import { ArrowLeft } from 'lucide-react';

const DatenschutzPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <div className="bg-slate-900 py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <a 
            href="/" 
            className="inline-flex items-center gap-2 text-white/70 hover:text-white transition-colors mb-4"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Startseite
          </a>
          <h1 className="text-3xl sm:text-4xl font-bold text-white">Datenschutzerklärung</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-lg p-8 lg:p-12 space-y-8">
          
          {/* Einleitung */}
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">1. Datenschutz auf einen Blick</h2>
            <h3 className="text-lg font-semibold text-slate-800 mb-2">Allgemeine Hinweise</h3>
            <p className="text-slate-700">
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren 
              personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene 
              Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. 
              Ausführliche Informationen zum Thema Datenschutz entnehmen Sie unserer unter diesem 
              Text aufgeführten Datenschutzerklärung.
            </p>
          </section>

          {/* Datenerfassung */}
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">2. Datenerfassung auf dieser Website</h2>
            
            <h3 className="text-lg font-semibold text-slate-800 mb-2 mt-6">
              Wer ist verantwortlich für die Datenerfassung auf dieser Website?
            </h3>
            <div className="text-slate-700 space-y-2">
              <p>
                Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. 
                Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle" 
                in dieser Datenschutzerklärung entnehmen.
              </p>
            </div>

            <h3 className="text-lg font-semibold text-slate-800 mb-2 mt-6">
              Wie erfassen wir Ihre Daten?
            </h3>
            <div className="text-slate-700 space-y-2">
              <p>
                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. 
                Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
              </p>
              <p>
                Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website 
                durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. 
                Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser 
                Daten erfolgt automatisch, sobald Sie diese Website betreten.
              </p>
            </div>

            <h3 className="text-lg font-semibold text-slate-800 mb-2 mt-6">
              Wofür nutzen wir Ihre Daten?
            </h3>
            <p className="text-slate-700">
              Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu 
              gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.
            </p>

            <h3 className="text-lg font-semibold text-slate-800 mb-2 mt-6">
              Welche Rechte haben Sie bezüglich Ihrer Daten?
            </h3>
            <div className="text-slate-700 space-y-2">
              <p>
                Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und 
                Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem 
                ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine 
                Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung 
                jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten 
                Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu 
                verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen 
                Aufsichtsbehörde zu.
              </p>
              <p>
                Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an 
                uns wenden.
              </p>
            </div>
          </section>

          {/* Hosting */}
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">3. Hosting</h2>
            <p className="text-slate-700">
              Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
            </p>
            <h3 className="text-lg font-semibold text-slate-800 mb-2 mt-4">Externes Hosting</h3>
            <div className="text-slate-700 space-y-2">
              <p>
                Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser 
                Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei 
                kann es sich v. a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, 
                Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, die über 
                eine Website generiert werden, handeln.
              </p>
              <p>
                Das externe Hosting erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren 
                potenziellen und bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse 
                einer sicheren, schnellen und effizienten Bereitstellung unseres Online-Angebots 
                durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).
              </p>
            </div>
          </section>

          {/* Verantwortliche Stelle */}
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">4. Hinweis zur verantwortlichen Stelle</h2>
            <div className="text-slate-700 space-y-2">
              <p>Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:</p>
              <div className="mt-4 p-4 bg-slate-50 rounded-lg">
                <p className="font-semibold">Sunprojects GmbH</p>
                <p>Michael Kaufmann</p>
                <p>Bornbachstraße 80</p>
                <p>35789 Weilmünster</p>
                <p className="mt-2">Telefon: +49 2235 9762339</p>
                <p>E-Mail: info@sunprojects-gmbh.de</p>
              </div>
              <p className="mt-4">
                Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder 
                gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von 
                personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
              </p>
            </div>
          </section>

          {/* Speicherdauer */}
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">5. Speicherdauer</h2>
            <p className="text-slate-700">
              Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt 
              wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die 
              Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen 
              oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, 
              sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer 
              personenbezogenen Daten haben (z. B. steuer- oder handelsrechtliche 
              Aufbewahrungsfristen); im letztgenannten Fall erfolgt die Löschung nach Fortfall 
              dieser Gründe.
            </p>
          </section>

          {/* Rechte */}
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">6. Ihre Rechte</h2>
            
            <h3 className="text-lg font-semibold text-slate-800 mb-2">Recht auf Auskunft</h3>
            <p className="text-slate-700 mb-4">
              Sie haben das Recht, jederzeit unentgeltlich Auskunft über Ihre bei uns gespeicherten 
              personenbezogenen Daten zu erhalten.
            </p>

            <h3 className="text-lg font-semibold text-slate-800 mb-2">Recht auf Berichtigung</h3>
            <p className="text-slate-700 mb-4">
              Sie haben das Recht, die Berichtigung unrichtiger personenbezogener Daten zu verlangen.
            </p>

            <h3 className="text-lg font-semibold text-slate-800 mb-2">Recht auf Löschung</h3>
            <p className="text-slate-700 mb-4">
              Sie haben das Recht, die Löschung Ihrer personenbezogenen Daten zu verlangen, sofern 
              nicht gesetzliche Aufbewahrungspflichten entgegenstehen.
            </p>

            <h3 className="text-lg font-semibold text-slate-800 mb-2">Recht auf Einschränkung der Verarbeitung</h3>
            <p className="text-slate-700 mb-4">
              Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten 
              zu verlangen.
            </p>

            <h3 className="text-lg font-semibold text-slate-800 mb-2">Recht auf Datenübertragbarkeit</h3>
            <p className="text-slate-700 mb-4">
              Sie haben das Recht, Ihre Daten in einem strukturierten, gängigen und 
              maschinenlesbaren Format zu erhalten.
            </p>

            <h3 className="text-lg font-semibold text-slate-800 mb-2">Beschwerderecht bei der Aufsichtsbehörde</h3>
            <p className="text-slate-700">
              Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung 
              Ihrer personenbezogenen Daten zu beschweren.
            </p>
          </section>

          {/* Kontaktformular */}
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">7. Kontaktformular</h2>
            <div className="text-slate-700 space-y-2">
              <p>
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus 
                dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks 
                Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. 
                Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>
              <p>
                Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, 
                sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur 
                Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen 
                beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven 
                Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf 
                Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.
              </p>
              <p>
                Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns 
                zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck 
                für die Datenspeicherung entfällt (z. B. nach abgeschlossener Bearbeitung Ihrer 
                Anfrage). Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen – 
                bleiben unberührt.
              </p>
            </div>
          </section>

          {/* Cookies */}
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-4">8. Cookies</h2>
            <div className="text-slate-700 space-y-2">
              <p>
                Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind kleine 
                Datenpakete und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder 
                vorübergehend für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft 
                (permanente Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies werden nach 
                Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies bleiben auf Ihrem 
                Endgerät gespeichert, bis Sie diese selbst löschen oder eine automatische Löschung 
                durch Ihren Webbrowser erfolgt.
              </p>
              <p>
                Cookies können von uns (First-Party-Cookies) oder von Drittunternehmen stammen 
                (sog. Third-Party-Cookies). Third-Party-Cookies ermöglichen die Einbindung 
                bestimmter Dienstleistungen von Drittunternehmen innerhalb von Webseiten 
                (z. B. Cookies zur Abwicklung von Zahlungsdienstleistungen).
              </p>
              <p>
                Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies 
                informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies 
                für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der 
                Cookies beim Schließen des Browsers aktivieren.
              </p>
            </div>
          </section>

        </div>

        {/* Footer Note */}
        <p className="text-center text-slate-500 text-sm mt-8">
          Stand: Dezember 2025
        </p>
      </div>
    </div>
  );
};

export default DatenschutzPage;
